'use client'
import { jsx } from "react/jsx-runtime";
import { format } from "date-fns/format";
import { useState } from "react";
import { DayPicker } from "react-day-picker";
import { enUS } from "react-day-picker/locale";
import { cn } from "../../../utils/index.js";
import { HeatMapDayButton } from "../CustomComponents/HeatMapDayButton.js";
import { NextMonthButton, PreviousMonthButton } from "../CustomComponents/MonthButtons.js";
import { getHoveredDateRange } from "../helpers/helpers.js";
import { DayMapProvider } from "../Providers/DayMapProvider.js";
import { calendarVariants } from "./Calendar.variants.js";
const DEFAULT_TIMEZONE = 'America/Toronto';
function Calendar({ mode = 'single', numberOfMonths = 1, captionLayout = 'label', selected, handleCalendarChange, min, max, startMonth, endMonth, onMonthChange, className, isMobile, timeZone = DEFAULT_TIMEZONE, components: customComponents, dayMap, lowestPrice, ...restProps }) {
    const [selectedDates, setSelectedDates] = useState(selected);
    const [hoveredRangeDays, setHoveredRangeDays] = useState([]);
    const handleSelect = (value, triggerDate)=>{
        setSelectedDates(value);
        setHoveredRangeDays([]);
        handleCalendarChange(value, triggerDate);
    };
    const styles = calendarVariants({
        isMobile,
        isDayMap: !!dayMap?.data
    });
    const classNames = {
        root: cn(styles.root(), className),
        month_caption: styles.monthCaption(),
        button_previous: styles.buttonPrevious(),
        button_next: styles.buttonNext(),
        caption_label: styles.captionLabel(),
        nav: styles.nav(),
        months: styles.months(),
        month: styles.month(),
        weekdays: styles.weekdays(),
        week_row: styles.weekRow(),
        week_header: styles.weekHeader(),
        day: styles.day(),
        day_button: styles.dayButton(),
        selected: styles.selectedDays(),
        today: styles.today(),
        outside: styles.outsideDay(),
        weeks: styles.weeks(),
        week: styles.week(),
        weekday: styles.weekday(),
        week_number: styles.weekNumber(),
        chevron: styles.chevron(),
        month_grid: styles.monthGrid(),
        range_start: styles.rangeStart(),
        range_middle: styles.rangeMiddle(),
        range_end: styles.rangeEnd(),
        hovered_range_start: styles.hoveredRangeStart(),
        hovered_range_end: styles.hoveredRangeEnd(),
        disabled: styles.disabled(),
        hidden: styles.hidden()
    };
    const props = {
        mode,
        classNames,
        formatters: {
            formatWeekdayName: (weekday, options)=>format(weekday, 'ccc', options)
        },
        min,
        max,
        numberOfMonths,
        startMonth,
        endMonth,
        locale: enUS,
        timeZone,
        captionLayout,
        onMonthChange,
        components: {
            NextMonthButton: NextMonthButton,
            PreviousMonthButton: PreviousMonthButton,
            DayButton: HeatMapDayButton,
            ...customComponents
        },
        fixedWeeks: !isMobile,
        selected: selected || selectedDates,
        onSelect: handleSelect,
        hideNavigation: !!isMobile,
        modifiers: {
            hoveredRangeStart: [
                hoveredRangeDays[0]
            ],
            hoveredRange: hoveredRangeDays.slice(1, hoveredRangeDays.length - 1),
            hoveredRangeEnd: [
                hoveredRangeDays[hoveredRangeDays.length - 1]
            ]
        },
        modifiersClassNames: {
            hoveredRangeStart: styles.hoveredRangeStart(),
            hoveredRange: styles.rangeMiddle(),
            hoveredRangeEnd: styles.hoveredRangeEnd()
        },
        onDayMouseEnter: (day)=>{
            const dates = getHoveredDateRange(mode, day, selectedDates);
            setHoveredRangeDays(dates);
        },
        footer: customComponents?.Footer ? 'Footer' : null,
        ...restProps
    };
    return /*#__PURE__*/ jsx(DayMapProvider, {
        dayMap: dayMap,
        mode: mode,
        lowestPrice: lowestPrice,
        children: /*#__PURE__*/ jsx(DayPicker, {
            ...props
        })
    });
}
export { Calendar };
